function FollowUsIconsRow() {
  return <div style={{ width: 'min-content' }}>*Icons*</div>;
}

export default FollowUsIconsRow;
